module.exports = __webpack_public_path__ + "static/images/tp_xj_click.202506031717.png";